module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JY8knI/tc-custom/9783988268457.jpg?1704453358946",
      "alt": "This image is the cover for the book Children of the Lens, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Children of the Lens, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Arisians have played a long-term strategic game to defeat the Eddorians, a malevolent race seeking domination and destruction. Now, Kinnison and MacDougall, along with their children, are the \"Children of the Lens\" and the key to the ultimate battle against the Eddorians. The lens, a device of immense power and intelligence, enhances the abilities of its wielders, allowing them to face formidable challenges and adversaries. The story unfolds as the Children of the Lens employ their newfound powers to outmaneuver the Eddorians and bring an end to their reign of terror. Throughout the novel, readers are taken on a thrilling journey through the cosmos, witnessing epic space battles, intricate strategies, and the realization of the Arisians' plan to defeat evil and ensure the survival of a free and peaceful galaxy. \"Children of the Lens\" is a grand conclusion to the Lensman series, offering an action-packed, imaginative narrative that explores the ultimate struggle between good and evil on a cosmic scale, emphasizing the triumph of wisdom, courage, and unity over darkness and tyranny.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      E. E. Smith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Edward Elmer Smith, also known as E. E. \"Doc\" Smith, (May 2, 1890 – August 31, 1965) was an American author and a pioneer in the science fiction genre, particularly known for his space opera series. He played a significant role in shaping early science fiction, especially in the realm of space adventures and interstellar conflicts.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0